import $ from 'jquery'
import ChartHierarchicalSelectorsSectionStrategy from './ChartHierarchicalSelectorsSectionStrategy'
import {Errors} from './constants'

function OvertimeHoursHierarchicalSelectorsSectionStrategy({showUserSelector, overtimeUserSelector}) {
    this.params = {
        showUserSelector,
        overtimeUserSelector,
    }
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype = new ChartHierarchicalSelectorsSectionStrategy();

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function() {
    ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI.call(this)
    if (this.params.showUserSelector) {
        $(this.container).addClass(this.getVisibleOvertimeUsersSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName())
    } else {
        $(this.container).addClass(this.getVisibleUsernameClassName())
    }
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return this.params.showUserSelector
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return this.params.overtimeUserSelector.getSelection()
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function()
{
    return {
        userSelection: this.params.overtimeUserSelector.getSelection()
    };
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.validate = function()
{
    const errors = [];

    if ( !this.validateIsUserSelected() )
        errors.push( Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION );

    return errors;
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return this.params.overtimeUserSelector.validateIsUserSelected()
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    this.params.overtimeUserSelector.setSelection(selection)
}

export default OvertimeHoursHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/OvertimeHoursHierarchicalSelectorsSectionStrategy.js